export default __webpack_public_path__ + "static/media/news59.d47cea76.jpg";